const COGNITO_REGEX = 'Cognito.*'

export default () => {
  const cookieList = (document.cookie) ? document.cookie.split('; ') : []
  const cookieDict = Object.fromEntries(cookieList.map((c) => c.split('=')))

  return Object.keys(cookieDict).some((c) => c.match(COGNITO_REGEX))
}
